import Axios from 'axios'
import config from '../config'

export const getInfos = async () => {
  const URL = `${config.baseURL}${config.apiURL}customers/avance-immediate/infos`
  const response = await Axios.get(URL)
  return response.data
}

export const sendInfos = async (infos) => {
  const URL = `${config.baseURL}${config.apiURL}customers/avance-immediate/infos`
  const response = await Axios.post(URL, infos)
  return response.data
}

export const changeUsageAvanceImmediate = async (enable) => {
  const URL = `${config.baseURL}${config.apiURL}customers/avance-immediate/infos/usage`
  const response = await Axios.put(URL, enable, { headers: { 'Content-Type': 'application/json' } })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/avanceImmediate.js